export default "__VITE_ASSET__CO0HAyei__"